"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsPageUSBComponents = void 0;
var _react = _interopRequireDefault(require("react"));
var _DmsAltBox = require("../../components/DmsAltBox/DmsAltBox");
var _DmsPage = require("../../components/DmsPage/DmsPage");
var _DmsUSBComponents = require("../../components/DmsUSBComponent/DmsUSBComponents");
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _material = require("@mui/material");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const DmsPageUSBComponents = () => {
  return /*#__PURE__*/_react.default.createElement(_DmsPage.DmsPage, {
    name: "Components"
  }, /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Card, null, /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Header, null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "h3",
    sx: {
      fontSize: '1.1rem'
    }
  }, _reactIntlUniversal.default.get("USBComponents").d("USB Components"))), /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Body, null, /*#__PURE__*/_react.default.createElement(_DmsUSBComponents.DmsUSBComponents, null))));
};
exports.DmsPageUSBComponents = DmsPageUSBComponents;